export enum CrmTypesEnum {
    CONNECTHEARING="Connect Hearing",
    ELITE="Elite",
    ALPACA="Alpaca"
}
